/**
 * CMS Plugins Index
 * Registers all available CMS plugins
 */

import { pluginRegistry } from "./registry.jsx";

// Import all plugins
import cmsFieldSet from "./cms-field-set.jsx";
import cmsAddField from "./cms-add-field.jsx";
import cmsReplaceText from "./cms-replace-text.jsx";
import cmsRenameField from "./cms-rename-field.jsx";
import cmsVisualizer from "./cms-visualizer.jsx";
import cmsExport from "./cms-export.jsx";

// Register all plugins
pluginRegistry.register(cmsFieldSet);
pluginRegistry.register(cmsAddField);
pluginRegistry.register(cmsReplaceText);
pluginRegistry.register(cmsRenameField);
pluginRegistry.register(cmsVisualizer);
pluginRegistry.register(cmsExport);

// Export registry and helper functions
export { pluginRegistry, createPluginContext } from "./registry.jsx";
export { default as PluginDialog } from "./PluginDialog.jsx";
